import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faHeartPulse,
  faXRay,
  faSyringe, 
  faVial, 
  faBriefcaseMedical,
  faStethoscope,
  faBedPulse,
  faNotesMedical
} from '@fortawesome/free-solid-svg-icons';
import '../App.css';
import './ServicesPage.css';

const ServiceCard = ({ title, items, icon, subtitle }) => (
  <div className="service-card">
    <div className="card-header">
      <div className="icon-container">
        <FontAwesomeIcon icon={icon} />
      </div>
      <div>
        <h3>{title}</h3>
        {subtitle && <div className="service-subtitle">{subtitle}</div>}
      </div>
    </div>
    <ul>
      {items.map((item, index) => (
        <li key={index}>{item}</li>
      ))}
    </ul>
  </div>
);

const ServicesPage = () => {
  const navigate = useNavigate();

  const scrollToFastCare = (e) => {
    e.preventDefault();
    // Navigate to home page first
    navigate('/');
    // Wait for the home page to load
    setTimeout(() => {
      const element = document.getElementById('fast-care');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }, 100);
  };
  const services = [
    {
      title: 'Urgent Care',
      icon: faHeartPulse,
      items: [
        'Strep Testing',
        'Mono Testing',
        'Flu Testing',
        'UTI testing and treatment',
        'Fracture Care',
        'Splinting',
        'Laceration Repair'
      ]
    },
    {
      title: 'Diagnostic Imaging',
      icon: faXRay,
      items: [
        'X-rays',
        'Referrals for MRI and specialty imaging'
      ]
    },
    {
      title: 'Minor Procedures',
      icon: faBedPulse,
      items: [
        'Skin Biopsies',
        'Lesion Removal',
        'Abscess and Cyst Drainage'
      ]
    },
    {
      title: 'Laboratory & Testing',
      icon: faVial,
      items: [
        'Labs / Blood Work',
        'Pregnancy Testing'
      ]
    },
    {
      title: 'Vaccinations',
      icon: faSyringe,
      items: [
        'Flu Shots (Not billable to insurance)',
        'Tetanus Vaccination'
      ]
    },
    {
      title: 'Specialized Treatments',
      icon: faNotesMedical,
      items: [
        'Joint Injections',
        'Trigger Point Injections',
        'Weight Loss'
      ]
    },
    {
      title: 'Employer Paid Services',
      icon: faBriefcaseMedical,
      items: [
        'Annual & Pre-employment Physicals',
        'Drug Screening',
        'Vision Testing',
        'Pulmonary Function Test (PFT)',
        'Hearing Testing',
        'EKG'
      ]
    },
    {
      title: 'Physicals & Screenings',
      icon: faStethoscope,
      items: [
        'DOT/CDL Physicals and License Renewals',
        'Employer Paid Services',
        'Drug Screens',
        'Pre-employment Physicals',
        'TB Testing',
        'Tetanus and Other Vaccination Updates',
        'School Physicals',
        'Sports Physicals'
      ]
    }
  ];

  return (
    <div className="App">
      <main className="services-container">
        <div className="services-header">
          <h1 className="services-title">Our Services</h1>
          <p className="services-subtitle">Comprehensive urgent care and medical services to meet all your healthcare needs. Walk-ins welcome - join our waitlist for faster service.</p>
        </div>
        <div className="services-grid">
          {services.map((service, index) => (
            <ServiceCard 
              key={index}
              title={service.title}
              items={service.items}
              icon={service.icon}
              subtitle={service.subtitle}
            />
          ))}
        </div>
        
        {/* Customized Healthcare Solutions Section */}
        <div className="custom-solutions-section">
          <div className="solutions-overlay"></div>
          <div className="solutions-content">
            <h2>Customized Healthcare Solutions</h2>
            <p>
              We can customize services for businesses or individuals based on your specific needs. 
              Contact us to discuss how we can support your healthcare requirements.
            </p>
            <a 
              href="/#fast-care" 
              className="cta-button"
              onClick={scrollToFastCare}
            >
              Contact Us
            </a>
          </div>
        </div>
      </main>
    </div>
  );
};

export default ServicesPage;
